import React, { forwardRef, useCallback, useImperativeHandle, useLayoutEffect, useRef } from "react";
import { createDiceAnimator, ROLL_DURATION } from "./diceMotion";

const faces = [
  ["front", ["c"]], ["back", ["tl", "tr", "ml", "mr", "bl", "br"]],
  ["right", ["tl", "c", "br"]], ["left", ["tl", "tr", "bl", "br"]],
  ["top", ["tl", "tr", "c", "bl", "br"]], ["bottom", ["tl", "br"]],
];
export function DiceMark({ size = 24 }) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" aria-hidden="true"><rect x="4" y="4" width="16" height="16" rx="4" />{[[8, 8], [16, 8], [12, 12], [8, 16], [16, 16]].map(([x, y]) => <circle key={`${x}:${y}`} cx={x} cy={y} r="1" fill="currentColor" />)}</svg>;
}

const DiceArt = forwardRef(function DiceArt(_, ref) {
  const root = useRef(null), animator = useRef(null), stop = useRef(null);
  useLayoutEffect(() => {
    animator.current = createDiceAnimator(root.current);
    return () => { stop.current?.(); animator.current = null; };
  }, []);
  const roll = useCallback(() => new Promise(resolve => {
    stop.current?.();
    const motion = animator.current;
    if (!motion) { resolve(); return; }
    let frame = null, done = false;
    const finish = () => {
      if (done) return;
      done = true; if (frame != null) cancelAnimationFrame(frame);
      document.removeEventListener("visibilitychange", onVisibility);
      window.removeEventListener("pagehide", finish);
      motion.finish(); stop.current = null; resolve();
    };
    const onVisibility = () => { if (document.hidden) finish(); };
    stop.current = finish; motion.start();
    if (document.hidden || window.matchMedia?.("(prefers-reduced-motion: reduce)")?.matches) { finish(); return; }
    document.addEventListener("visibilitychange", onVisibility);
    window.addEventListener("pagehide", finish);
    const start = performance.now();
    const animate = now => {
      if (done) return;
      const elapsed = Math.max(0, now - start); motion.update(elapsed);
      if (elapsed >= ROLL_DURATION) finish(); else frame = requestAnimationFrame(animate);
    };
    frame = requestAnimationFrame(animate);
  }), []);
  useImperativeHandle(ref, () => ({ roll }), [roll]);
  return <div className="dice-art" ref={root} aria-hidden="true"><div className="dice-rig">{["back", "front"].map(name =>
    <div className={`rolling-die rolling-die--${name}`} key={name}><span className="die-shadow" /><div className="die-lift"><div className="die-angle"><div className="die-cube">{faces.map(([side, pips]) => <div className={`die-face die-face--${side}`} key={side}>{pips.map(pip => <i className={`pip pip--${pip}`} key={pip} />)}</div>)}</div></div></div></div>
  )}</div></div>;
});
export default DiceArt;
